<template>
  <section>
    <sc-logs-api-table
      title="Últimas 10 chamadas"
      :table-data="logs" />
  </section>
</template>
<script>
  import { createNamespacedHelpers } from 'vuex';
  import ScLogsApiTable from '../sc-logs-api-table/ScLogsApiTable';

  const { mapState, mapActions } = createNamespacedHelpers('analytic/logsApi');
  export default {
    name: 'sc-logs-api-list-all',
    computed: {
      ...mapState([
        'logs',
      ]),
    },
    methods: {
      ...mapActions([
        'getAllLogs',
      ]),
    },
    created() {
      this.getAllLogs();
    },
    components: {
      ScLogsApiTable,
    },
  };
</script>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-analytic/features/logs/pages/api/components/sc-logs-api-list-all/ScLogsApiListAll.vue